import { ChevronDown, ChevronRight, Plus, Trash2 } from "lucide-react";
import { useState } from "react";
import { Button } from "../../../../../components/ui/button";
import { Input } from "../../../../../components/ui/input";
import useSkillsStore from "../../../../../store/skills/skillsStore";

const SkillTemplatesSection = () => {
  const templates = useSkillsStore((s) => s.editor.templates);
  const addTemplate = useSkillsStore((s) => s.addTemplate);
  const updateTemplate = useSkillsStore((s) => s.updateTemplate);
  const removeTemplate = useSkillsStore((s) => s.removeTemplate);
  const [collapsed, setCollapsed] = useState(templates.length === 0);

  return (
    <div className="mt-5 border-t border-border pt-5">
      <button
        type="button"
        onClick={() => setCollapsed(!collapsed)}
        className="flex w-full items-center justify-between text-sm font-medium text-foreground"
      >
        <span className="flex items-center gap-1.5">
          {collapsed ? (
            <ChevronRight className="h-3.5 w-3.5" />
          ) : (
            <ChevronDown className="h-3.5 w-3.5" />
          )}
          Output Templates
          {templates.length > 0 && (
            <span className="text-xs text-muted-foreground">
              ({templates.length})
            </span>
          )}
        </span>
        <Button
          variant="ghost"
          size="sm"
          onClick={(e) => {
            e.stopPropagation();
            addTemplate();
            setCollapsed(false);
          }}
        >
          <Plus className="h-3.5 w-3.5" />
          Add
        </Button>
      </button>

      {!collapsed && (
        <div className="mt-3 flex flex-col gap-4">
          {templates.length === 0 ? (
            <p className="text-xs text-muted-foreground">
              No output templates. Add one to define structured output for this
              skill.
            </p>
          ) : (
            templates.map((template, index) => (
              <div
                key={index}
                className="rounded-lg border border-border bg-card p-3"
              >
                <div className="flex items-center gap-2 mb-2">
                  <Input
                    placeholder="Template name"
                    value={template.template_name}
                    onChange={(e) =>
                      updateTemplate(index, { template_name: e.target.value })
                    }
                    className="flex-1"
                  />
                  <select
                    value={template.template_type}
                    onChange={(e) =>
                      updateTemplate(index, {
                        template_type: e.target.value,
                      })
                    }
                    className="h-8 rounded-[5px] border border-border-chip bg-card px-2 text-[13px] focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-primary"
                  >
                    <option value="markdown">Markdown</option>
                    <option value="json">JSON</option>
                    <option value="html">HTML</option>
                    <option value="csv">CSV</option>
                    <option value="email">Email</option>
                    <option value="slack">Slack</option>
                  </select>
                  <button
                    type="button"
                    onClick={() => removeTemplate(index)}
                    className="rounded p-1 text-muted-foreground hover:bg-muted hover:text-status-cancelled"
                  >
                    <Trash2 className="h-3.5 w-3.5" />
                  </button>
                </div>
                <textarea
                  placeholder="Template content..."
                  value={template.template_content}
                  onChange={(e) =>
                    updateTemplate(index, { template_content: e.target.value })
                  }
                  rows={4}
                  className="w-full rounded-[5px] border border-border-chip bg-background px-2 py-1.5 font-mono text-[12px] leading-relaxed placeholder:text-muted-foreground/50 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-primary resize-none"
                  spellCheck={false}
                />
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
};

export default SkillTemplatesSection;
